import { Controller } from "@hotwired/stimulus";

interface City {
  cityId: number;
  cityName: string;
}

// Connects to data-controller="city-selector"
export default class extends Controller {
  static targets = ["prefecture", "city"];
  declare readonly prefectureTarget: HTMLSelectElement;
  declare readonly cityTarget: HTMLSelectElement;

  connect() {
    requestAnimationFrame(() => {
      const selectedPrefectureId = Number(this.prefectureTarget.value);
      // 都道府県が選択されていない場合は何もしない
      if (!selectedPrefectureId) return;

      const selectedCityId = this.cityTarget.dataset.selected;

      // 選択されている都道府県の市区町村を取得し、すでに選択されている市区町村があれば選択状態にする
      this.fetchCities(selectedPrefectureId).then((cities) => {
        this.updateCityOptions(cities);

        if (selectedCityId) {
          const optionToSelect = this.cityTarget.querySelector(
            `option[value="${selectedCityId}"]`
          ) as HTMLOptionElement;

          if (optionToSelect) {
            optionToSelect.selected = true;
          }
        }

        this.cityTarget.disabled = false; // 市区町村セレクトボックスを有効化
      });
    });
  }

  // 都道府県選択時に発火
  async selectPrefecture(event: Event) {
    const prefectureId = Number((event.currentTarget as HTMLSelectElement).value);
    if (!prefectureId) return;

    const cities = await this.fetchCities(prefectureId);
    this.updateCityOptions(cities);
  }

  // APIで市区町村を取得
  private async fetchCities(prefectureId: number): Promise<City[]> {
    try {
      const response = await fetch(`/api/internal/v1/prefectures/${prefectureId}/cities`);
      const json = await response.json();

      const cities = (json.data || []).map((city: any) => ({
        cityId: city.city_id,
        cityName: city.city_name,
      }));

      return cities;
    } catch (error) {
      console.error("市区町村の取得に失敗しました", error);
      return [];
    }
  }

  // 市区町村セレクトボックスを更新
  private updateCityOptions(cities: City[]): void {
    const fragment = document.createDocumentFragment();

    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "市区町村を選択";
    fragment.appendChild(defaultOption);

    cities.forEach(city => {
      const option = document.createElement("option");
      option.value = String(city.cityId);
      option.textContent = city.cityName;
      fragment.appendChild(option);
    });

    this.cityTarget.innerHTML = "";
    this.cityTarget.appendChild(fragment);
    this.cityTarget.disabled = cities.length === 0;
  }
}
